import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom"; 
import { UserProvider } from "./context/UserContext";
import { GrupoProvider } from "./context/GrupoContext";  // ← IMPORTANTE
import { AuthProvider } from "./context/AuthContext";
import { AlertProvider } from "./context/AlertContext";
import Alert from "./pages/Alert";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AlertProvider>
        <UserProvider>
          <GrupoProvider>     
            <AuthProvider>
              <App />
              <Alert />
            </AuthProvider>
          </GrupoProvider>
        </UserProvider>
      </AlertProvider>
    </BrowserRouter>
  </React.StrictMode>
);


